import {
  EmployeeRoles as Roles,
  EmployeeStatuses as Statuses,
} from 'app/constants';

const RoleLabels = {
  [Roles.EMPLOYEE]: 'Employee',
  [Roles.ADMIN]: 'All-Access Admin',
  [Roles.FINANCE]: 'Finance Team',
  [Roles.CHAMPION]: 'Impact Champion',
  [Roles.GROUP_LEAD]: 'Group Lead',
  [Roles.IT]: 'IT Admin',
};
const RoleSimpleLabels = {
  [Roles.EMPLOYEE]: 'Employee',
  [Roles.ADMIN]: 'Admin',
  [Roles.FINANCE]: 'Finance',
  [Roles.CHAMPION]: 'Champion',
  [Roles.GROUP_LEAD]: 'Group Lead',
  [Roles.IT]: 'IT',
};
const roleLabel = (role) => {
  return RoleLabels[role] || role;
};
const roleSimpleLabel = (role) => {
  return RoleSimpleLabels[role] || role;
};

const StatusLabels = {
  [Statuses.PENDING]: 'Pending',
  [Statuses.ACTIVE]: 'Active',
  [Statuses.DEACTIVATED]: 'Deactivated',
};
const statusLabel = (status) => {
  return StatusLabels[status] || status;
};

export default {
  Roles,
  Statuses,
  roleLabel,
  roleSimpleLabel,
  statusLabel,
};
